import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
//import { FinancialNetCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { FinancialSectionsSetFilterService } from './../services/financial-sections-set-filter.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-financial-summaries-items',
    templateUrl: './financial-summaries-items.component.html',
    styleUrls: ['./financial-summaries-items.component.scss'],
    standalone: false
})
export class FinancialSummariesItemsComponent implements OnInit, OnDestroy {
  public subscription: Subscription;
  public subscription2: Subscription;
  public filter: string = "";
  public title = "";
  public total = 0;
  public myUser;
  public myItemsList: {};
  public items: {}[] = [];
  public multiplier = 1;
  
  @Input() public myCategoriesBalance: {}[];
  constructor(private userInfo: UserInfoService,
    private financialItemsSetFilterService: FinancialSectionsSetFilterService,
    private zenplanData: ZpDataService, public themeService: ThemeService) { }

  ngOnInit() {
    this.subscription = this.userInfo.getMessage().subscribe(async user => {
      this.myUser = await JSON.parse(user);
    });
    this.subscription2 = this.financialItemsSetFilterService.getMessage().subscribe(async filter => {
      this.filter = filter;
      this.filterList(filter);
    });
  }

  async filterList(filter) {
    if (filter) {
      this.myItemsList = await this.zenplanData.getPlanSectionInfo(this.myUser, filter);
      this.title = this.myItemsList["sectionName"];
      if (("my debts_my daily life").includes(this.myItemsList["category"]["planCategory"])) {
        this.multiplier = -1;
      }
      this.total = this.myItemsList["grandTotal"] * this.multiplier;
      this.items = this.myItemsList["items"];
      this.items.forEach(item => {
        item["itemTotal"] = item["itemTotal"] * this.multiplier;
      })
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
  }

}
